var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class AspectInteractTimed {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspectInteract() {
        return this.parent;
    }
    get aspect() {
        return this.aspectInteract.aspect;
    }
    get app() {
        return this.aspect.context.app;
    }
    get actor() {
        return this.parent.actor;
    }
    get latest() {
        return this.aspect.aspectEvents.latestEventOfType;
    }
    get hoverTime() {
        if (this.latest.mouseenter && this.aspectInteract.isAspectHovering) {
            return this.app.appClock.clock_100.tickingTime - this.latest.mouseenter.appTime;
        }
        return 0;
    }
    get activeTime() {
        if (this.latest.mousedown && this.aspectInteract.isAspectActive) {
            return this.app.appClock.clock_100.tickingTime - this.latest.mousedown.appTime;
        }
        return 0;
    }
    get hoverGoneTime() {
        if (this.latest.mouseleave && !this.aspectInteract.isAspectHovering) {
            return this.app.appClock.clock_100.tickingTime - this.latest.mouseleave.appTime;
        }
        return 0;
    }
    get hoverWasTime() {
        return (this.latest.mouseenter && this.latest.mouseleave && this.latest.mouseleave.appTime - this.latest.mouseenter.appTime) || 0;
    }
}
__decorate([
    computed
], AspectInteractTimed.prototype, "hoverTime", null);
__decorate([
    computed
], AspectInteractTimed.prototype, "activeTime", null);
__decorate([
    computed
], AspectInteractTimed.prototype, "hoverGoneTime", null);
